import {AchievedRecord} from "./AchievedRecord";

// 100-1000
const appends = new Array(9).fill(null).map((_,i) => (i+1)*100)
                             .concat(new Array(9).fill(null).map((_,i) => (i+1)*1000))
                             .concat(new Array(10).fill(null).map((_,i) => (i+1)*10000))
// {contentType}-{metricName}をkeyにする
// 連続も合計も欲しい時はmetricNameの名前を分けてそれぞれcheck()を呼ぶ
export const COUNT_ACHIEVE_TYPE = {
  'jogging-dist': []
    .concat(new Array(9).fill(null).map((_,i) => (i+1)*1000))
    .concat(new Array(9).fill(null).map((_,i) => (i+1)*10000))
    .concat(new Array(9).fill(null).map((_,i) => (i+1)*100000)),
  'seiken-count': [10, 50].concat(appends),
  'crunch-count': [10, 50].concat(appends),
  'squat-count': [10, 50].concat(appends),
  'dumbbell-curl-count': [10, 50].concat(appends),
}

export class CountAchieveDetector {
  constructor(cache) {
    this.cache = cache
    this.onAchieved = null
  }

  checkCountType(type, diff) {
    const cachedObj = this.cache.getCache(type)
    const total = (cachedObj['count'] || 0) + diff
    const lastAchieved = cachedObj['lastAchieved'] || 0
    COUNT_ACHIEVE_TYPE[type].forEach(goal => {
      if (!this.onAchieved) return
      if (total < goal || goal <= lastAchieved) return

      cachedObj['lastAchieved'] = goal
      cachedObj['achievedTime'] = new Date().getTime()
      this.onAchieved({ type, goal })
    })
    cachedObj['count'] = total
    this.cache.setCache(type, cachedObj)
  }

  getAchievements() {
    const achievements = []
    Object.keys(COUNT_ACHIEVE_TYPE).forEach(type => {
      const cachedObj = this.cache.getCache(type)
      const lastAchieved = cachedObj['lastAchieved']
      const achievedTime = cachedObj['achievedTime'] || 0
      if (lastAchieved) {
        achievements.push(new AchievedRecord({ type, goal: lastAchieved, achievedTime }))
      }
    })
    return achievements.sort((a,b) => {
      if (a.achievedTime === b.achievedTime) return 0
      return a.achievedTime < b.achievedTime ? 1 : -1
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/CountAchieveDetector.js